import React from 'react';
import sample from '../../resources/media/ci_sample.png';
import ontap from '../../resources/media/ontap.svg';
import kubernetes from '../../resources/media/kubernetes.svg';
import cs from '../../resources/media/workloadSecurity.svg'
import CigHeader from '../CigHeader';
import {isStaging, isServiceCmUri} from '../../common/utils';
import {
    CM_CANVAS_URL,
    CM_PROD_URL,
    CM_STAGING_URL,
} from '../../common/constants';


export function NoCmTenantFoundPage() {

    const addWorkingEnvironment = (e) => {
        e.preventDefault();
        const canvasUrl = (isStaging() ? CM_STAGING_URL : CM_PROD_URL) + CM_CANVAS_URL;
        window.open(canvasUrl, '_self');
    }
    return (
        <div id="no-cm-tenant-found-container">
            <CigHeader id="no-cm-tenant-found-header" cmMode={isServiceCmUri()} showLogout={false}></CigHeader>
            <div id="no-cm-body-top" className="tw-flex tw-w-full tw-bg-gray-200">
                <div id="no-cm-observability-body" className="tw-flex tw-m-auto" style={{width: '75%'}}>
                    <div className="tw-pb-2xl" style={{width: '65%'}}>
                        <div id="no-cm-msg-box" className="tw-w-auto"  style={{maxWidth: '700px'}}>
                            <div className="tw-mx-28px tw-py-xl">
                                <p id="no-cm-observability" className="tw-not-italic tw-text-40px tw-font-normal tw-leading-12">
                                    Observability
                                </p>
                                <p id="no-cm-highlight-text" className="tw-not-italic tw-font-medium tw-text-xl">
                                    End-to-end hybrid cloud observability, powered by Data Infrastructure Insights
                                </p>
                                <p id="no-cm-msg" className="tw-text-16px tw-font-normal tw-not-italic tw-pt-xl tw-leading-relaxed">
                                    Data Infrastructure Insights lets you monitor and optimize your complex, hybrid cloud environment with proactive capacity and performance management, resource optimization and advanced insider threat protection.
                                </p>
                                <p id="no-cm-button-explain-text" className="tw-text-16px tw-font-normal tw-not-italic tw-pt-18px tw-pb-xl tw-leading-relaxed">
                                    You need to add a Cloud Volumes ONTAP working environment in either AWS or Azure. This will trigger the activation of an Observability tenant.
                                </p>
                                <button id="no-cm-working-environment-button"
                                    className="tw-border tw-border-netapp-blue tw-py-6px tw-px-20px tw-rounded-md tw-text-white tw-bg-netapp-blue hover:tw-bg-blue-500"
                                    onClick={addWorkingEnvironment} >
                                    Add a working environment
                                </button>
                            </div>
                        </div>
                    </div>
                    <div id="no-cm-tenant-sample-image" style={{width: '65%'}}>
                        <div id="sample-image" className="tw-flex">
                            <div id="ci-sample-image" style={{paddingTop: '75px'}}>
                                <img src={sample} className="tw-shadow-lg" alt={'Data Infrastructure Insights'} width={640} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div id="no-cm-footer" className="tw-bg-white tw-w-full tw-flex">
                <div id="no-cm-footer-body" className="tw-flex tw-m-auto tw-mt-48px" style={{width: '75%'}}>
                    <div className="tw-justify-center tw-grid tw-grid-cols-3 tw-grid-rows-3 tw-col-gap-20px">
                        <div id="ontap-icon" className="tw-m-auto tw-text-center">
                            <img src={ontap} alt="OnTap" width={72} className="tw-m-auto"/>
                        </div>
                        <div id="kubernetes-icon" className="tw-m-auto tw-text-center">
                            <img src={kubernetes} alt="Kubernetes" width={72} className="tw-m-auto"/>
                        </div>
                        <div id="cloud-secure-icon" className="tw-m-auto tw-text-center">
                            <img src={cs} alt="Storage Workload Security" width={72} className="tw-m-auto"/>
                        </div>
                        <div id="ontap-text" className="tw-text-20px tw-not-italic tw-font-medium tw-pt-8px tw-text-center tw-m-auto">
                            ONTAP Essentials
                        </div>
                        <div id="kubernetes-text" className="tw-text-20px tw-not-italic tw-font-medium tw-pt-8px tw-text-center tw-m-auto">
                            Kubernetes
                        </div>
                        <div id="cloud-secure-text" className="tw-text-20px tw-not-italic tw-font-medium tw-pt-8px tw-text-center tw-m-auto">
                            Storage Workload Security
                        </div>
                        <div id="ontap-msg" className="tw-text-med tw-font-normal tw-not-italic tw-text-center tw-leading-relaxed tw-pt-6px">
                            Manage NetApp platforms and services end-to-end, on and off-cloud, with all the benefits of SaaS
                        </div>
                        <div id="kubernetes-msg" className="tw-text-med tw-font-normal tw-not-italic tw-text-center tw-leading-relaxed tw-pt-6px">
                            Control resource utilization and ensure predictable performance for Hybrid and Multi-Cloud Kubernetes
                        </div>
                        <div id="cs-msg" className="tw-text-med tw-font-normal tw-not-italic tw-text-center tw-leading-relaxed tw-pt-6px">
                            Protect sensitive corporate data from insider threads with advanced user behavior analysis and automated thread response policies
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

NoCmTenantFoundPage.displayName = 'NoCmTenantFoundPage';
export default NoCmTenantFoundPage;
